import Axios from "axios";
import { Location } from '../models/location';

export class LocationService {

  private static _api = Axios.create({
    baseURL: process.env.VUE_APP_ECE_API_URL,
    responseType: 'json',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-api-key': 'eaQSPYWOqAbDOpjX3zFC2bDJvh6z7wB3wV888d25'
    }
  });

  static async getActive(): Promise<Location[]> {
    const response = await this._api.get<Location[]>(`/Locations`);
    const allLocations = response.data;
    return allLocations.filter( l => l.active === true);
  }

  static async getLocationsByLatLonMiles(lat: number, lon: number, numMiles: number): Promise<Location[]> {
    const response = await this._api.get<Location[]>(`/Locations?lat=${lat}&lon=${lon}&miles=${numMiles}`);
    return response.data;
  }
}
